<template>
  <component :is="dataTag">
    <p v-if="isLoading" class="visually-hidden-focusable">
      Contenuto in caricamento
    </p>
    <slot />
  </component>
</template>

<script>
export default {
  name: 'LoadingCmp',
  props: {
    dataTag: {
      type: String,
      default: 'div',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
.loading {
  &:before {
    content: '';
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw !important;
    height: 100vh !important;
    background: rgba(0, 0, 0, 0.2);
    z-index: map_get($z, overlay);
  }

  &:after {
    content: '';
    display: block;
    position: fixed;
    top: 50%;
    left: 50%;
    width: 48px !important;
    height: 48px !important;
    min-width: 0;
    min-height: 0;
    color: rgba(255, 255, 255, 1);
    border: 5px solid;
    border-right-color: rgba(0, 0, 0, 0.8);
    border-radius: 50%;
    background: none;
    transform: translateX(-50%) translateY(-50%);
    animation: rotate 1s linear infinite;
    z-index: map_get($z, modal);
  }
}
</style>
